import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useQueryApplicationSearchCount from "./useQueryApplicationSearchCount";

export default function ApprovedApplicationByJobCountItem(props) {
  const { jobId } = props;
  const { data: count, loading, errors } = useQueryApplicationSearchCount(jobId);

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <Row>
            <Col>
              <span>{count}</span>
            </Col>
          </Row>
        )}
      />
    </HorizontalLoader>
  );
}
